import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

import api from '../../services/api';

import {
  AMODULO_SISAREPASSENGER,
  AMODULO_CRM,
  AMODULO_ESTOQUE,
  AMODULO_FINANCAS,
  AMODULO_GERENCIAL,
  AMODULO_RECEPTIVO,
  AMODULO_ADMAPPCLI,
  AMODULO_FROTAS,
  AMODULO_PARTNER
} from 'consts';

const Logout = props => {
  const { history } = props;

  useEffect(() => {
    async function executarLogout() {
      const modulo = sessionStorage.getItem('modulo');
      const partnerPortal = sessionStorage.getItem('partnerPortal');

      try {
        /*
         * Usa a instância api:
         * - envia o Bearer automaticamente;
         * - envia o cookie por causa do withCredentials.
         */
        await api.post('/logout');

      } catch (error) {
        /*
         * Mesmo que a API esteja indisponível, a sessão local
         * deve ser removida.
         */
        console.error('Erro ao encerrar sessão na API:', error);

      } finally {
        sessionStorage.removeItem('sisare_access_token');
        sessionStorage.removeItem('token');

        sessionStorage.removeItem('user');
        sessionStorage.removeItem('usuario');
        sessionStorage.removeItem('codUser');
        sessionStorage.removeItem('lastLogin');
        sessionStorage.removeItem('isTechnicalUser');

        sessionStorage.removeItem('codModulo');
        sessionStorage.removeItem('mesComboProd');
        sessionStorage.removeItem('anoComboProd');
        sessionStorage.removeItem('moeda');
        sessionStorage.removeItem('trabOutraMoeda');
        sessionStorage.removeItem('formaPDV');
        sessionStorage.removeItem('codEmpresa');
        sessionStorage.removeItem('mod-ger-tipoExtraFat');
        sessionStorage.removeItem('fantasia');

        sessionStorage.removeItem('modulo');
        sessionStorage.removeItem('localizador');
        sessionStorage.removeItem('codOS');
        sessionStorage.removeItem('exportaLayoutA2x');
        sessionStorage.removeItem('nomePax');
        sessionStorage.removeItem('exportaContabil');
        sessionStorage.removeItem('identEmpCtbPeloSetor');
        sessionStorage.removeItem('trabProgramacaoSugestivo');
        sessionStorage.removeItem('trabHsServDiaEspec');
        sessionStorage.removeItem('trabTipoPadraoServico');
        sessionStorage.removeItem('codPDV');

        sessionStorage.removeItem('idPartner');
        sessionStorage.removeItem('emailPartner');
        sessionStorage.removeItem('usuarioPartner');
        sessionStorage.removeItem('partnerPortal');

        sessionStorage.removeItem('pdv');
        sessionStorage.removeItem('empresa');
        sessionStorage.removeItem('cfg');
        sessionStorage.removeItem('cfg_financas');
        sessionStorage.removeItem('cfg_crm');
        sessionStorage.removeItem('dicionarioDadosFornecedor');

        switch (parseInt(modulo, 10)) {
          case AMODULO_RECEPTIVO:
            history.replace('/front');
            break;

          case AMODULO_FINANCAS:
            history.replace('/financas');
            break;

          case AMODULO_GERENCIAL:
            history.replace('/gerencial');
            break;

          case AMODULO_ESTOQUE:
            history.replace('/estoque');
            break;

          case AMODULO_CRM:
            history.replace('/crm');
            break;

          case AMODULO_SISAREPASSENGER:
            history.replace('/appcli');
            break;

          case AMODULO_ADMAPPCLI:
            history.replace('/admappcli');
            break;

          case AMODULO_FROTAS:
            history.replace('/frotas');
            break;

          case AMODULO_PARTNER:
            history.replace(
              partnerPortal === 'partner'
                ? '/partner'
                : '/admpartner'
            );
            break;

          default:
            history.replace('/login');
            break;
        }
      }
    }

    executarLogout();
  }, [history]);

  return null;
};

Logout.propTypes = {
  history: PropTypes.object.isRequired
};

export default withRouter(Logout);